import apiClient from './apiClient'

export const getSiteData = () => apiClient.get('/api/SiteData')
